module.exports = __webpack_public_path__ + "img/world.553c8afe.svg";